import { supabase } from '../lib/supabase';

export const storageService = {
	// Upload image to Supabase Storage
	async uploadImage(file, bucket = 'images', path = '') {
		try {
			const fileExt = file.name.split('.').pop();
			const fileName = `${Date.now()}.${fileExt}`;
			const filePath = path ? `${path}/${fileName}` : fileName;

			const { data, error } = await supabase.storage
				.from(bucket)
				.upload(filePath, file);

			if (error) throw error;

			// Get public URL
			const { data: urlData } = supabase.storage
				.from(bucket)
				.getPublicUrl(filePath);

			return { data: urlData.publicUrl, error: null };
		} catch (error) {
			console.error('Error uploading image:', error);
			return { data: null, error };
		}
	},

	// Get public URL for an image
	async getImageUrl(bucket, path) {
		try {
			const { data } = supabase.storage
				.from(bucket)
				.getPublicUrl(path);

			return { data: data.publicUrl, error: null };
		} catch (error) {
			console.error('Error getting image URL:', error);
			return { data: null, error };
		}
	},

	// Delete image from storage
	async deleteImage(bucket, path) {
		try {
			const { error } = await supabase.storage
				.from(bucket)
				.remove([path]);

			if (error) throw error;
			return { error: null };
		} catch (error) {
			console.error('Error deleting image:', error);
			return { error };
		}
	},

	// List images in a bucket
	async listImages(bucket, path = '') {
		try {
			const { data, error } = await supabase.storage
				.from(bucket)
				.list(path);

			if (error) throw error;

			// Transform the data to include URLs and proper structure
			const transformedData = data?.map(file => ({
				name: file.name,
				size: file.metadata?.size || 0,
				url: supabase.storage.from(bucket).getPublicUrl(file.name).data.publicUrl,
				created_at: file.created_at,
				updated_at: file.updated_at
			})) || [];

			return { data: transformedData, error: null };
		} catch (error) {
			console.error('Error listing images:', error);
			return { data: null, error };
		}
	},

	// Delete file from storage (alias for deleteImage)
	async deleteFile(bucket, path) {
		return this.deleteImage(bucket, path);
	},

	// Upload multiple images
	async uploadMultipleImages(files, bucket = 'images', path = '') {
		try {
			const uploadPromises = files.map(file => 
				this.uploadImage(file, bucket, path)
			);

			const results = await Promise.all(uploadPromises);
			const successful = results.filter(result => !result.error);
			const failed = results.filter(result => result.error);

			return {
				data: successful.map(result => result.data),
				errors: failed.map(result => result.error),
				error: failed.length > 0 ? 'Some uploads failed' : null
			};
		} catch (error) {
			console.error('Error uploading multiple images:', error);
			return { data: null, error };
		}
	}
};
